export default __webpack_public_path__ + "static/media/MySLR_file_import.d69363bb.mp4";